module.exports = __webpack_public_path__ + "static/media/image_12.d98bf7f7.png";